module.exports = __webpack_public_path__ + "img/scene3@2x.e8a783d7.png";